<template>
  <div
    class="header-page"
    :class="{'header-page_only-title': !filteredLinks}">
    <div class="flex header-page-top">
      <span class="header-page__name">{{namePage}}</span>
        <div class="header-inputs">
          <div class="header-input" v-if="isSearchInput">
            <input
              type="text"
              v-model="amoSearch"
              :placeholder="$t('mc.placeholders.searchByAmocrm')"
              @keyup.enter="searchByAmoId"
              class="header-input__search input-text">
            <button
              class="header-input__icon clear"
              @click="clearAmoSearch"
              v-if="amoSearch">
              <img
                svg-inline
                src="@/assets/svg/close.svg">
            </button>
            <button
              class="header-input__icon"
              @click="searchByAmoId"
              >
              <img
                svg-inline
                src="@/assets/svg/search.svg">
            </button>
          </div>
        </div>
    </div>
    <div class="header-page-links" v-if="filteredLinks">
      <router-link
        v-for="(link, i) in filteredLinks"
        :key="i"
        :to="link.link"
        class="header-page-link">
          {{$t(link.name)}}
        </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderPage',
  props: {
    namePage: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      required: false
    },
    isSearchInput: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      amoSearch: '',
    }
  },
  computed: {
    userRole() {
      return this.$store.state.user.user.role;
    },
    filteredLinks() {
      if (!this.links) return [];

      const isManagerLinks = this.links.some(
        (link) =>
          link.link === '/master-classes/manager/timetable/' ||
          link.link === '/master-classes/manager/my-timetable/'
      );

      if (isManagerLinks) {
        return this.links.map((link) => {
          if (
            link.link === '/master-classes/manager/timetable/' &&
            this.userRole !== 'admin'
          ) {
            return null;
          }
          if (
            link.link === '/master-classes/manager/my-timetable/' &&
            this.userRole !== 'manager'
          ) {
            return null;
          }
          return link;
        }).filter(Boolean);
      }
      return this.links;
    }
  },
  methods: {
    clearAmoSearch() {
      this.amoSearch = ''
      this.$emit('clearSearchInput')
    },
    searchByAmoId() {
      if (!this.amoSearch) return
      this.$emit('searchByAmoId', this.amoSearch)
    },
    clearAmoId() {
      this.amoSearch = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.header-input{
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  // padding: 0 10px;
  position: relative;
  width: 345px;
  &__search {
    margin: 0;
    width: 100%;
    text-align: left;
    padding-left: 45px;
    padding-right: 30px;
  }
  &__icon {
    background: none;
    border: none;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.clear {
  right: 15px;
  left: auto;
  & > img {
    width: 15px;
    height: 15px;
  }
}

.header-page {
  // margin-bottom: 40px;
  padding: 32px 80px 0 80px;
  background: #fff;
  height: 166px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &-top {
    justify-content: space-between;
    align-items: center;
  }
  &_only-title {
    padding-bottom: 32px;
    justify-content: center;
    & .header-page__name {
      margin: 0;
    }
  }
  &__name {
    font-weight: 700;
    font-size: 28px;
    display: block;
    color: var(--black-title)
  }
  &-links {
    display: flex;
    justify-content: flex-start;
  }
  &-link {
    white-space: nowrap;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 20px;
    color: #000;
    border-bottom: 3px solid transparent;
    margin-right: 30px;
    &:last-child {
      margin-right: 0;
    }
    &.router-link-active {
      color: var(--main-blue);
      border-color: var(--main-blue);
    }
  }
}
</style>
